<template>
  <div>
    <v-card
      :style="`
      border: ${border_px}px solid ${border_color};
      `"
      flat
      tile
      :color="bgcolor"
    >
      <v-card-text>
        <v-textarea
          :color="color"
          v-model="ans"
          counter
          label="คำตอบ"
          outlined
          clearable
          style="font-size: 18px"
          rows="3"
          :rules="[$store.getters.TextRule(ans)]"
        ></v-textarea>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "bgcolor",
    "color",
    "color_text",
    "border_px",
    "border_color",
  ],
  data() {
    return {
      ans: null,
    };
  },
  watch: {
    ans() {
      this.$emit("Answer", this.ans);
    },
  },
  methods: {
    setAns(ans) {
      this.ans = ans;
    },
  },
};
</script>

<style lang="scss" scoped></style>
